export default __webpack_public_path__ + "static/media/icon-polished.c4682372.svg";